import { render, staticRenderFns } from "./updateOffer.vue?vue&type=template&id=c806cb26&scoped=true&"
import script from "./updateOffer.vue?vue&type=script&lang=js&"
export * from "./updateOffer.vue?vue&type=script&lang=js&"
import style0 from "./updateOffer.vue?vue&type=style&index=0&id=c806cb26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c806cb26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VRow})
